import React from 'react';
import { Spin } from 'antd';
import { Loading3QuartersOutlined } from '@ant-design/icons';

export default function GlobalLoader({ isLoading }) {
    return (
        <>
            {isLoading ? (
                <div className="global-loader__overlay">
                    <Spin
                        indicator={
                            <Loading3QuartersOutlined
                                className="global-loader__icon"
                                spin
                            />
                        }
                    />
                </div>
            ) : (
                <></>
            )}
        </>
    );
}
